<mat-icon
  *ngFor="let role of rolesDetails"
  #tooltip="matTooltip"
  matTooltipClass="tooltip"
  matTooltipPosition="above"
  [matTooltip]="role.tooltip"
  >{{ role.icon }}</mat-icon
>
